import { Heading, Stack } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import { useEffect, useMemo, useState } from 'react'

import { useListTicketsQuery } from '../../api'
import { doneListColumns } from './Columns'
import { useSyncTickets } from './WatchList'

import { DataTable, FetchingIndicator } from '@/components/Elements'
import { getUserId } from '@/features/auth'

export const DoneList = () => {
    const [query, setQuery] = useState(() => ({
        page: 1,
        limit: 10,
        sort: 'distributedAt',
        direction: 'desc',
        userId: getUserId(),
        status: 'completed',
        type: 'auto',
    }))
    const [initialState] = useState(() => ({
        sortBy: [{ id: query.sort, desc: query.direction === 'desc' }],
        pageSize: query.limit,
    }))
    const { data, isFetching } = useListTicketsQuery(query)
    const [, { isLoading }] = useSyncTickets()
    return (
        <FetchingIndicator as={Stack} isFetching={isFetching || isLoading}>
            <Heading>候補者履歴</Heading>
            {data && (
                <Table
                    initialState={initialState}
                    items={data.items}
                    pageCount={data.paging.pageCount}
                    setQuery={setQuery}
                />
            )}
        </FetchingIndicator>
    )
}

const Table = ({ setQuery, pageCount, items, initialState }) => {
    const state = DataTable.useServerSide({
        data: items,
        columns: doneListColumns,
        pageCount,
        initialState,
    })
    const {
        state: { pageIndex, sortBy },
    } = state

    // useMemoでクエリパラメータを計算
    const queryParams = useMemo(() => {
        const { id, desc } = sortBy[0]
        return {
            page: pageIndex + 1,
            sort: id,
            direction: desc ? 'desc' : 'asc',
        }
    }, [pageIndex, sortBy])

    // 計算されたパラメータが変更された時のみsetQueryを実行
    useEffect(() => {
        setQuery((prev) => ({
            ...prev,
            ...queryParams,
        }))
    }, [setQuery, queryParams])
    return (
        <DataTable.Provider {...state}>
            <DataTable.Table>
                <DataTable.Head />
                <DataTable.Body />
            </DataTable.Table>
            <DataTable.Pagination />
        </DataTable.Provider>
    )
}
Table.propTypes = {
    initialState: PropTypes.any.isRequired,
    pageCount: PropTypes.number.isRequired,
    items: PropTypes.array.isRequired,
    setQuery: PropTypes.func.isRequired,
}
